
import React from 'react';
import { Staff, Shift } from '../types';

const TimesheetView: React.FC<{ staff: Staff[], shifts: Shift[] }> = ({ staff, shifts }) => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="ymca-brand-font text-4xl">Timesheets & Payroll</h2>
        <div className="flex items-center space-x-2">
          <span className="text-sm text-gray-500">Period: 16 Oct - 22 Oct</span>
          <button className="px-4 py-2 bg-ymca-green text-white rounded-lg font-bold">Export for Payroll</button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
          <h4 className="text-gray-500 text-sm font-bold uppercase mb-2">Total Hours Worked</h4>
          <p className="text-3xl font-bold">1,240h</p>
          <p className="text-xs text-ymca-green font-bold mt-1">Within Budget Limits</p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
          <h4 className="text-gray-500 text-sm font-bold uppercase mb-2">Unapproved Entries</h4>
          <p className="text-3xl font-bold">12</p>
          <p className="text-xs text-ymca-red font-bold mt-1">Requires Action</p>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
          <h4 className="text-gray-500 text-sm font-bold uppercase mb-2">Avg Shift Rating</h4>
          <p className="text-3xl font-bold">4.8/5</p>
          <p className="text-xs text-gray-400 font-bold mt-1">Based on staff feedback</p>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200">
        <div className="p-6 border-b border-gray-100 flex justify-between items-center">
          <h3 className="text-lg font-bold">Recent Clock-ins</h3>
          <input type="date" className="border-gray-300 rounded-lg text-sm" />
        </div>
        <div className="p-6">
          <p className="text-gray-500 italic text-center py-8">Select a staff member to view detailed clock-in/out logs and geofence verification.</p>
        </div>
      </div>
    </div>
  );
};

export default TimesheetView;
